exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fuller[data-v-77f92d20]{height:calc(100% - 5rem)}", ""]);

// exports
